import { IS_CONSOLIDATED_SESSIONS_LIST_ENABLED } from '@/features/flags';
import { type SessionListVersion } from '@/models/analytics/features/sessions';
import { useShouldUseUpcomingSessions } from './useShouldUseUpcomingSessions';

/**
 * Single source of truth for which sessions-list variant is active:
 *
 * - `'consolidated'` — `IS_CONSOLIDATED_SESSIONS_LIST_ENABLED()` (takes precedence)
 * - `'v2'` — upcoming sessions enabled and the user has no EHR integration or a
 *   letter-sender one (see {@link useShouldUseUpcomingSessions})
 * - `'v1'` — otherwise (including non-letter-sender EHR integration users)
 *
 * Consumed by every variant renderer (desktop sidebar, mobile panel,
 * sidebar-panel loader) and by schedule-upload analytics
 * (`session_list_version`), so rollout changes here propagate everywhere at
 * once instead of drifting across hand-copied switches.
 */
export const useSessionListVersion = (): SessionListVersion => {
  const shouldUseUpcomingSessions = useShouldUseUpcomingSessions();

  if (IS_CONSOLIDATED_SESSIONS_LIST_ENABLED()) return 'consolidated';
  return shouldUseUpcomingSessions ? 'v2' : 'v1';
};
